// Catalog products the intake hides from every catalog checkout (product card
// and the "Choose your dosage & strength" list), whatever the flow's own filter
// says. Applied before the flow filter AND to its "filter matched nothing"
// fallback, so a hidden product can't come back through either path.
//
// Tesamorelin hidden 2026-09-24 until it's offered again: delete it from this
// pattern and restore the 'Tesamorelin' tag on the LandingPage Build Muscle card.
// Follow-ups for patients already on it use CheckoutStep, not this list.
export const HIDDEN_MEDICATION_RE = /tesamorelin/i;

export const isHiddenMedication = (item) =>
  !!item && HIDDEN_MEDICATION_RE.test(`${item.name || ''} ${item.medication || ''}`);
